import GreaterthanIcon from './GreaterthanIcon'

export default GreaterthanIcon
